import React from "react";

const JCB = () => (
  <svg
    width="35"
    height="25"
    viewBox="0 0 35 25"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g fill="none" fillRule="evenodd">
      <rect width="35" height="25" fill="#FFF" rx="4"></rect>
      <path
        fill="#46A548"
        fillRule="nonzero"
        d="M26.2 3C24.4 3 23 4.4 23 6.2V9h4.9c.9-.1 1.7.7 1.8 1.6v.1c0 .9-.6 1.6-1.5 1.7 1 0 1.8.8 1.9 1.8 0 1-.9 1.8-1.9 1.8H23v6h4.7c1.8 0 3.2-1.4 3.2-3.2V3h-4.7zM25 14.9h2.3c.5-.2.8-.7.7-1.3-.1-.3-.4-.6-.7-.7H25v2zm2.8-4c0-.4-.3-.8-.7-.9H25v1.8h2.1c.4-.1.7-.5.7-.9z"
      ></path>
      <path
        fill="#D02644"
        fillRule="nonzero"
        d="M17.2 3C15.4 3 14 4.4 14 6.2V10c.8-.8 2.2-1.3 4.5-1.2.9.1 1.7.2 2.5.4v1.5c-.7-.4-1.6-.7-2.4-.8-1.4-.1-2.6.9-2.8 2.2-.1 1.4.9 2.6 2.2 2.8h.5c.9-.1 1.7-.4 2.4-.8v1.5c-.8.2-1.7.4-2.5.4-2.3.1-3.7-.4-4.5-1.2v7h4.8c1.8 0 3.2-1.4 3.2-3.2V3h-4.7z"
      ></path>
      <path
        fill="#1B6BAF"
        fillRule="nonzero"
        d="M5 6.2v8c.8.5 1.7.8 2.7.8.9 0 1.6-.7 1.7-1.6V9h2.7v4.2c0 1.6-.9 3-3.8 3-1.1 0-2.2-.2-3.2-.4V22h4.8c1.8 0 3.2-1.4 3.2-3.2V3H8.2C6.4 3 5 4.4 5 6.2z"
      ></path>
    </g>
  </svg>
);

export default JCB;
